import React from 'react'

//
import FacebookIcon from '../../../src/storybook/Icon/icons/social/facebook-icon.js'
import TwitterIcon from '../../../src/storybook/Icon/icons/social/twitter-icon.js'
import InstagramIcon from '../../../src/storybook/Icon/icons/social/instagram-icon.js'
import LinkedinIcon from '../../../src/storybook/Icon/icons/social/linkedin-icon.js'
import YoutubeIcon from '../../../src/storybook/Icon/icons/social/youtube-icon.js'

const iconMap = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  youtube: YoutubeIcon
}

const Socials = ({ title = '', socials = [] }) => {
  return (
    <div className="c-socials">
      {title && <span className="c-socials__title">{title}</span>}

      <ul className="c-socials__list">
        {socials.map((item) => {
          const SocialIcon = iconMap[item.label.toLowerCase()]

          return (
            <li key={item.id} className="c-socials__list-item">
              <a
                className="c-socials__list-item-link"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                title={item.label}
              >
                <SocialIcon color="red" />
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Socials
